import { IAuthResponse } from "../../models/dto/IAuthResponse";
import { IAuthRepositoryCB } from "../interfaces/repository/IAuthRepository";
import { ILocalRepositoryCB } from "../interfaces/repository/ILocalRepository";

export const SaveAuthUseCase = (auth: IAuthResponse, _authRepository: IAuthRepositoryCB) => {

    const authLocalStorage = _authRepository();
    authLocalStorage.set(auth);
}
